import React from 'react'

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function Grid({word, direction, pieces, ...props}) {
    let rows = direction == 'V' ? word.length : 3;
    let cols = direction == 'V' ? 3 : word.length;

    let grid = []

    for (let r = 0; r < rows; r++) {
        let tempRow = []
        for (let c = 0; c < cols; c++) {
            tempRow.push(" ")
        }
        grid.push(tempRow)
    }

    let indexInWord = 0;
    if (direction == 'H') {
        pieces.forEach((piece, idx) => {
            let currLetter = word[indexInWord]
            if (props.vertPieces.has(piece)) {
                props.vertPieces.delete(piece)
                grid[1][indexInWord] = currLetter
                if (piece.indexOf(currLetter) == 0) {
                    grid[2][indexInWord] = piece[1]
                } else {
                    grid[0][indexInWord] = piece[0]
                }
                indexInWord++
            } else if (props.horizPieces.has(piece)) {
                props.horizPieces.delete(piece)
                grid[1][indexInWord] = currLetter
                grid[1][indexInWord+1] = word[indexInWord+1]
                indexInWord += 2
            } else {
                props.singlePieces.delete(piece)
                grid[1][indexInWord] = currLetter
                indexInWord++
            }
        })
    } else {
        pieces.forEach((piece, idx) => {
            let currLetter = word[indexInWord]
            if (props.horizPieces.has(piece)) {
                props.horizPieces.delete(piece)
                grid[indexInWord][1] = currLetter
                if (piece.indexOf(currLetter) == 0) {
                    grid[indexInWord][2] = piece[1]
                } else {
                    grid[indexInWord][0] = piece[0]
                }
                indexInWord++
            } else if (props.vertPieces.has(piece)) {
                props.vertPieces.delete(piece)
                grid[indexInWord][1] = currLetter
                grid[indexInWord+1][1] = word[indexInWord+1]
                indexInWord += 2
            } else {
                props.singlePieces.delete(piece)
                grid[indexInWord][1] = currLetter
                indexInWord++
            }
        })
    }

    return (
        <div>
            {grid.length != 0 && grid.map((row, indexR) => (
                <Row>
                    {row.map((value) => (
                        <Col xs={direction=='V' || word.length < 5 ? "2" : ""} className={`p-1 ${value == ' ' ? "invisible" : ""}`}>
                            <div className='bitesblock' >
                                <h1 className='text-center bitesletter'>{value}</h1>
                            </div>
                        </Col>
                    ))}
                </Row>
            ))}
                
        </div>
    )
}